<div class="list-item">
    <button title="Remove" alt="Remove" *ngIf="close" (click)="onCloseClick.emit($event)">X</button>

    <div class="main" title="download" [ngClass]="actionIcon">
        <span  (click)="onMainTextClick.emit($event)" [innerHTML]="mainText"></span>
    </div>

    <div  *ngIf="actionIcon!=''" class="action-icon" title="download" [ngClass]="actionIcon">
        <span (click)="onIconClick.emit($event)"></span>
    </div>

    <div *ngIf="actionText!=''" class="action">
        <span (click)="onActionTextClick.emit($event)">{{ actionText }}</span>
    </div>

    <div *ngIf="rightText!=''" class="right">
        <span (click)="onRightTextClick.emit($event)">{{ rightText }}</span>
    </div>

</div>
